var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jsp-headline",class:_vm.size},[(_vm.icon)?_c('Icon',{attrs:{"icon":_vm.icon,"size":_vm.size}}):_vm._e(),_c('h4',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }